import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Grid, Modal, ModalFooter, Spacer, Typography } from '@emburse/embark-core';
import { useEffect, useState } from 'react';
import { EmployeeSearch } from '../../components';
import { setDefaultCardholder as setDefaultCardholderPost } from '../../api/cardsGateway';
import { $t, useTranslation } from '../../hooks/useTranslation';
function DefaultCardholderModal({ show, defaultCardholder, onClose, onUpdateDefaultCardholder }) {
    useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        defaultCardholder: null
    });
    useEffect(() => {
        setFormData((prevstate) => ({
            ...prevstate,
            defaultCardholder
        }));
    }, [defaultCardholder]);
    return (_jsxs(Modal, { open: show, onClose: () => onClose && onClose(), isLoading: isLoading, modalHeader: $t('Select Default Cardholder'), modalFooter: _jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", onClick: () => onClose && onClose(), children: $t('Cancel') }), _jsx(Button, { disabled: !formData.defaultCardholder, onClick: () => {
                            setIsLoading(true);
                            setDefaultCardholderPost(formData.defaultCardholder)
                                .then((response) => {
                                if (response.Status === 'success') {
                                    onUpdateDefaultCardholder(formData.defaultCardholder);
                                }
                            })
                                .finally(() => {
                                setIsLoading(false);
                            });
                        }, children: $t('Confirm') })] }) }), children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "caption", display: "block", children: $t(`Certify will import all unassigned transactions to your Default Cardholder.
                        Previously imported transactions will not be changed.`) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(EmployeeSearch, { onSelect: (cardholder) => setFormData((prevState) => ({
                                ...prevState,
                                defaultCardholder: cardholder
                            })), style: { width: '100%' }, label: $t('Default Cardholder'), value: formData.defaultCardholder, error: !formData.defaultCardholder, helperText: !formData.defaultCardholder
                                ? $t('Please select a Default Cardholder')
                                : null }) })] }), _jsx(Spacer, { size: 8 })] }));
}
export { DefaultCardholderModal };
